export const blockIconsAlertError = (
	<span className='material-symbols-outlined'>error</span>
);
